import { create } from 'zustand'
import { type SelectionView, useSelectionStore } from '@/stores/selection-store'
import { snippetNodeId, snippetSelection } from './object-set'

interface SnippetSelectionState {
  selected: { caseId: string | null; id: string; row?: number } | null
  select: (caseId: string | null, objectId: string, view?: SelectionView) => boolean
  close: () => void
}

export const useSnippetSelection = create<SnippetSelectionState>(set => ({
  selected: null,
  select: (caseId, objectId, view = 'graph') => {
    const selected = snippetSelection(objectId)
    if (!selected) return false
    set({ selected: { caseId, ...selected } })
    useSelectionStore.getState().replace([snippetNodeId(selected.id)], view)
    useSelectionStore.getState().selectEdge(null, view)
    return true
  },
  close: () => set({ selected: null }),
}))
